import { createAPIConnection } from 'services';
import { BusinessUnitParams } from './interfaces';
import { requestHandler } from '../helpers';

const api = createAPIConnection('/catalog');

export const getBUs = async (posId?: string) => {
	return requestHandler<BusinessUnitParams[]>(api.get('/business-unities', { params: { posId } }));
};
